import { faEraser } from '@fortawesome/pro-solid-svg-icons'
import { HeadingItem } from 'components'
import { FilteredDetailInfo } from 'components/item-verification'
import { TripContext } from 'contexts'
import React, { FC, useContext } from 'react'
import { FilteredLicensePlate, LicensePlate, LicensePlateItem, OrderItem, OrderLicensePlate } from 'services/types'
import './filtered-lps.scss'

type Props = {
    licensePlates: LicensePlate[],
    onClickClearAll: () => void,
    onClickRemoveLp: (lp: FilteredLicensePlate) => void
}

export const FilteredLps: FC<Props> = ({ licensePlates, onClickClearAll, onClickRemoveLp }) => {
    const tripContext = useContext(TripContext)
    const orderLicensePlates: OrderLicensePlate[] = tripContext.orderLicensePlates.filter(olp => licensePlates.some(lp => lp.id === olp.licensePlateId))
    const licensePlateItems: LicensePlateItem[] = tripContext.licensePlateItems.filter(lpi => licensePlates.some(lp => lp.id === lpi.licensePlateId))
    const licencePlateOrderItems: OrderItem[] = tripContext.orderItems.filter(oi => licensePlateItems.some(lpi => lpi.lineItemId === oi.lineItemId))
    const orderItems: OrderItem[] = licencePlateOrderItems.filter(item => orderLicensePlates.some(olp => olp.orderId === item.orderId))
    const totalIemsNotVerified = orderItems.filter(oi => oi.verifiedMethod == null)
    const totalItemsVerified = orderItems.filter(oi => oi.verifiedMethod != null)

    return (
        <div className={'search-result-card-material'}>
            <HeadingItem text={`Filtered LPs`} rightHandIcon={{ icon: faEraser, size: '2x', color: 'rgb(235, 87, 87)' }} onClick={onClickClearAll} />
            {licensePlates.map(lp => <FilteredDetailInfo key={lp.id} licensePlate={lp} onClickRemoveLp={onClickRemoveLp} />)}
            <div className={'filtered-footer-row'}>
                <div className={`filtered-footer-content`}> Total Not Verified : {totalIemsNotVerified.length}</div>
                <div className={`filtered-footer-content`}> Total Verified : {totalItemsVerified.length}</div>
            </div>
        </div>
    )
}

